import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch, onMounted } from 'vue'
    import { useRoute } from '@common/composables'
    import { useSharePage } from '@DataSharing/Shares/pages-core'
    import '@common/Components/ValidationError.vue'

    
export default /*#__PURE__*/_defineComponent({
  __name: 'SharePage',
  setup(__props) {

    document.title = 'Share data'

    const route = useRoute()
    const provider = route.params.provider
    const resourceId = route.params.resourceId
    const shareId = route.params.shareId

    const organizationUnitId = ref()
    const workspaceId = ref()
    const projectId = ref()
    const userId = ref()
    const sharedAt = ref(null)
    const sharedFor = ref()
    const sharedWith = ref()
    const resourceProviderName = ref(provider)
    const emailsProviderName = ref()
    const emailsProviderGroups = ref()
    const emailsProviderConfig = computed(() => emailsProviderGroups.value ? JSON.stringify(emailsProviderGroups.value) : null)
    const exists = ref()
    const isPaused = ref()

    const {
        useDataShareEmailsProvidersQuery, useShareQuery, useEmailsAndGroupsQuery,
        useShareDataCommand, useDeleteShareCommand, usePauseSharingCommand, useResumeSharingCommand
    } = useSharePage()

    const { modelShareQueryV1, runShareQueryV1 } = useShareQuery(resourceProviderName, resourceId, shareId)

    const { modelDataShareEmailsProvidersQueryV1, runDataShareEmailsProvidersQueryV1 } = useDataShareEmailsProvidersQuery(organizationUnitId, workspaceId, projectId)

    const { modelEmailsAndGroupsQueryV1, runEmailsAndGroupsQueryV1 } = useEmailsAndGroupsQuery(organizationUnitId, workspaceId, projectId, emailsProviderName)

    const { invokeShareDataCommandV1, succeedShareDataCommandV1, validationErrors } = useShareDataCommand(
        shareId, organizationUnitId, workspaceId, userId, sharedAt, sharedFor, sharedWith,
        resourceProviderName, resourceId, emailsProviderName, emailsProviderConfig)

    const { invokeDeleteShareCommandV1, succeedDeleteShareCommandV1 } = useDeleteShareCommand(shareId, userId)
    const { invokePauseSharingCommandV1, succeedPauseSharingCommandV1 } = usePauseSharingCommand(shareId)
    const { invokeResumeSharingCommandV1, succeedResumeSharingCommandV1 } = useResumeSharingCommand(shareId)

    function handleDeleteShareCommandV1() {
        if (confirm(`Do you want to delete this share?`)) {
            invokeDeleteShareCommandV1()
        }
    }

    const shares = computed(() => modelShareQueryV1.value?.Shares || [])
    const isShared = computed(() => modelShareQueryV1.value && shares.value.length > 0)
    const newShareId = computed(() => modelShareQueryV1.value?.NewShareId)
    const organizationName = computed(() => modelShareQueryV1.value?.OrganizationUnitName)
    const workspaceName = computed(() => modelShareQueryV1.value?.WorkspaceName)
    const projectName = computed(() => modelShareQueryV1.value?.ProjectName)
    const resourceName = computed(() => modelShareQueryV1.value?.ResourceName)
    const resourceUrl = computed(() => modelShareQueryV1.value?.ResourceUrl)
    const numberOfShares = computed(() => modelShareQueryV1.value?.NumberOfShares)
    const sharedForAvailableHours = computed(() => modelShareQueryV1.value?.SharedForAvailableHours)
    const sharedForAvailableDays = computed(() => modelShareQueryV1.value?.SharedForAvailableDays)
    const authenticatedUserRequired = computed(() => modelShareQueryV1.value?.AuthenticatedUserRequired)

    const emails = computed(() => modelEmailsAndGroupsQueryV1.value?.Emails || [])
    const groups = computed(() => modelEmailsAndGroupsQueryV1.value?.Groups || [])

    const dataShareEmailsProviders = computed(() => modelDataShareEmailsProvidersQueryV1.value?.Providers ?? [])
    const selectedEmailsProvider = computed(() => dataShareEmailsProviders.value.find(_ => _.Name == emailsProviderName.value))

    onMounted(() => runShareQueryV1())

    watch(modelShareQueryV1, () => {
        const model = modelShareQueryV1.value
        organizationUnitId.value = model?.OrganizationUnitId
        workspaceId.value = model?.WorkspaceId
        projectId.value = model?.ProjectId
        userId.value = model?.AuthenticatedUserId
        sharedFor.value = model?.SharedFor;
        emailsProviderName.value = model?.EmailsProviderName
        emailsProviderGroups.value = model?.EmailsProviderGroups || []
        exists.value = model?.Exists
        isPaused.value = model?.IsPaused
        runDataShareEmailsProvidersQueryV1()
    })

    watch(emailsProviderName, val => val ? runEmailsAndGroupsQueryV1() : null)

    watch(succeedShareDataCommandV1, navigateToShareNotificationPageIfSucceed)
    watch(succeedDeleteShareCommandV1, navigateToResourceSharePageIfSucceed)
    watch(succeedPauseSharingCommandV1, navigateToResourceSharePageIfSucceed)
    watch(succeedResumeSharingCommandV1, navigateToResourceSharePageIfSucceed)

    function navigateToResourceSharePageIfSucceed(succeed: boolean) {
        if (succeed) location.href = `/#/sharing/resource/${resourceProviderName.value}/${resourceId}`
    }

    function navigateToShareNotificationPageIfSucceed(succeed: boolean) {
        if (succeed) location.href = `/#/sharing/share/notification/${shareId}`
    }

return { __sfc: true,route, provider, resourceId, shareId, organizationUnitId, workspaceId, projectId, userId, sharedAt, sharedFor, sharedWith, resourceProviderName, emailsProviderName, emailsProviderGroups, emailsProviderConfig, exists, isPaused, useDataShareEmailsProvidersQuery, useShareQuery, useEmailsAndGroupsQuery, useShareDataCommand, useDeleteShareCommand, usePauseSharingCommand, useResumeSharingCommand, modelShareQueryV1, runShareQueryV1, modelDataShareEmailsProvidersQueryV1, runDataShareEmailsProvidersQueryV1, modelEmailsAndGroupsQueryV1, runEmailsAndGroupsQueryV1, invokeShareDataCommandV1, succeedShareDataCommandV1, validationErrors, invokeDeleteShareCommandV1, succeedDeleteShareCommandV1, invokePauseSharingCommandV1, succeedPauseSharingCommandV1, invokeResumeSharingCommandV1, succeedResumeSharingCommandV1, handleDeleteShareCommandV1, shares, isShared, newShareId, organizationName, workspaceName, projectName, resourceName, resourceUrl, numberOfShares, sharedForAvailableHours, sharedForAvailableDays, authenticatedUserRequired, emails, groups, dataShareEmailsProviders, selectedEmailsProvider, navigateToResourceSharePageIfSucceed, navigateToShareNotificationPageIfSucceed }
}

})